import Button from "devextreme-react/button";
import { useContext } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { LoadPagePanel } from "../../../../components";
import { AR, FileTypes } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useSubmitTemplateChecklist } from "../api/submit-template-checklist";
import { RetailOrderContext } from "../context/RetailOrderContext";
import { UpdateRetailOrderResult } from "../types/UpdateRetailOrderResult";

export default function SubmitChecklistButton() {

	const { order, refetchOrder } = useContext(RetailOrderContext);

	const [searchParams] = useSearchParams();
	const returnUrl = encodeURIComponent(searchParams.get("returnUrl") ?? "");
	const navigate = useNavigate();
	const location = useLocation();

	const submitChecklist = useSubmitTemplateChecklist(
		order.details.retailOrderID,
		(result: UpdateRetailOrderResult) => {
			showSuccessMessage("Template Checklist has been submitted");

			const newActionRequiredID = result.activeARs.find(x => x == 120);
			const to = `/cfi/retail-order/${order.details.retailOrderID}/${newActionRequiredID}` +
				(!!returnUrl ? '?returnUrl=' + returnUrl : '');

			if (newActionRequiredID && location.pathname !== to) {
				navigate(to);
			}
			else {
				refetchOrder();
			}
		},
		(error) => showErrorMessage(error)
	);

	return (
		<>
			<Button
				elementAttr={{ 'data-testid': 'btn-submit-files' }}
				text="Submit Checklist"
				icon="Inscyth-Confirm"
				visible={order.details.activeARs.includes(AR.CfiToUploadTemplateChecklist)}
				disabled={submitChecklist.isLoading}
				onClick={() => {
					if (!order.details.files.find(x => x.fileTypeID === FileTypes.TemplateChecklist)) {
						showErrorMessage("Template Checklist is required, please upload before submitting")
					}
					else {
						submitChecklist.mutate();
					}
				}} >
			</Button>
			<LoadPagePanel visible={submitChecklist.isLoading}></LoadPagePanel>
		</>
	)
}
